import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IBaseDto } from '@http/clients/reporting-app/base-dto.service';
import { ReportingCompetingBidderSearchService } from '@services/http/clients/reporting-app/reporting-competing-bidder-search.service';
import { ReportsService } from '@services/reports.service';
import { CustomMenuItemComponent } from '@shared/custom-menu-item/custom-menu-item.component';
import { EditorComponentBase, GenericTypeAheadMultiselectComponent } from 'ngx-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reporting-competing-bidder-editor',
    templateUrl: './reporting-competing-bidder-editor.component.html',
    styleUrls: ['./reporting-competing-bidder-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadMultiselectComponent, CustomMenuItemComponent]
})
export class ReportingCompetingBidderEditorComponent
    extends EditorComponentBase<number[] | null>
    implements OnInit, OnDestroy
{
    items: IBaseDto[] = [];
    selectedItems?: IBaseDto[];
    subscription?: Subscription;

    private readonly reportingCompetingBidderSearchService = inject(ReportingCompetingBidderSearchService);
    private readonly reportsService = inject(ReportsService);

    constructor() {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
            if (ready && this.bindingProperty !== null && this.bindingProperty?.length) {
                this.selectedItems = await this.reportingCompetingBidderSearchService.getByIds(this.bindingProperty);
            } else if (ready && (this.bindingProperty === null || this.bindingProperty === undefined)) {
                this.selectedItems = [];
            }
        });
    }

    async onSelectedItemsChange(newSelectedItems: IBaseDto[]): Promise<void> {
        this.selectedItems = newSelectedItems;
        if (this.selectedItems.length) {
            this.bindingProperty = this.selectedItems.map((item) => item.id);
            this.valueChange.emit();
        }
    }

    async onEntityTextChange(text: string) {
        this.items = await this.reportingCompetingBidderSearchService.search(text);
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
